(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6498],{

/***/ 52544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MultilineText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function MultilineText(props) {
    if (!props.children) return null;
    var lines = props.children.split("\n");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: lines.map(function(line, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    line,
                    index !== lines.length - 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                ]
            }, index);
        })
    });
};


/***/ }),

/***/ 93865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ deleteCartItemMutation; }
/* harmony export */ });
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation deleteCartItem($cartItemId: ID) {\n    deleteCartItem(cartItemId: $cartItemId)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var deleteCartItemMutation = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject());


/***/ }),

/***/ 74322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMeta; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_websites_PageMetaContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31469);


function useMeta(subtitle, description, image, schema) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_helpers_websites_PageMetaContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), setSubtitle = ref.setSubtitle, setDescription = ref.setDescription, setImage = ref.setImage, setSchema = ref.setSchema;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setSubtitle(subtitle);
        setDescription(description);
        setImage(image);
        setSchema(schema);
        return function() {
            setSubtitle();
            setDescription();
            setImage();
            setSchema();
        };
    }, []);
};


/***/ }),

/***/ 82096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Options_UpdateBasicOptions; }
});

// UNUSED EXPORTS: UpdateBasicOptions

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ClientSuspense/index.tsx
var ClientSuspense = __webpack_require__(88385);
// EXTERNAL MODULE: ./src/components/fields/DeliveryType/index.tsx
var DeliveryType = __webpack_require__(35438);
// EXTERNAL MODULE: ./src/components/LoadingText/index.tsx + 1 modules
var LoadingText = __webpack_require__(69840);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/index.tsx
var SuspenseLoading = __webpack_require__(75288);
// EXTERNAL MODULE: ./src/helpers/websites/withWebsiteId.tsx
var withWebsiteId = __webpack_require__(91015);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Select/index.js
var Select = __webpack_require__(97338);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/decorators/withMessage.js
var withMessage = __webpack_require__(77543);
// EXTERNAL MODULE: ./node_modules/@packages/react-apollo-decorators/lib/withGraphQL.js
var withGraphQL = __webpack_require__(70791);
// EXTERNAL MODULE: ./node_modules/@packages/react-apollo-decorators/lib/withMutation.js
var withMutation = __webpack_require__(68688);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/StoreName/index.tsx
var StoreName = __webpack_require__(59450);
// EXTERNAL MODULE: ./node_modules/autobind-decorator/lib/esm/index.js
var esm = __webpack_require__(88572);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18446);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__(78718);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 37 modules
var dist_esm = __webpack_require__(12284);
// EXTERNAL MODULE: ./node_modules/simple-react-form/lib/index.js
var simple_react_form_lib = __webpack_require__(40191);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/Address/Update/index.tsx
var Update = __webpack_require__(89435);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/Time/index.tsx
var Time = __webpack_require__(84339);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/DeliveryOptions/styles.module.css
var styles_module = __webpack_require__(1159);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/DeliveryOptions/index.tsx





function DeliveryOptions(param) {
    var preferences = param.preferences, isFromHeader = param.isFromHeader, layout = param.layout;
    var address = preferences.address, store = preferences.store, placeId = preferences.placeId;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var time = store && address && !loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).selectTime,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Time/* default */.Z, {
            preferences: preferences,
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            showDirections: !!placeId && placeId !== "no-deliver"
        })
    }) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Update/* default */.Z, {
        preferences: preferences,
        autoSave: true,
        showOutOfBoundsMsg: true,
        showMapRight: layout === "v1" ? false : true,
        isFromHeader: isFromHeader,
        time: time,
        loading: loading,
        setLoading: setLoading
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/StoreMessage/index.tsx
var StoreMessage = __webpack_require__(13467);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/TableName/index.tsx + 1 modules
var TableName = __webpack_require__(99590);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/styles.module.css
var UpdateBasicOptions_styles_module = __webpack_require__(60170);
var UpdateBasicOptions_styles_module_default = /*#__PURE__*/__webpack_require__.n(UpdateBasicOptions_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/index.tsx
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc1 = {};
    Object.keys(descriptor).forEach(function(key) {
        desc1[key] = descriptor[key];
    });
    desc1.enumerable = !!desc1.enumerable;
    desc1.configurable = !!desc1.configurable;
    if ("value" in desc1 || desc1.initializer) {
        desc1.writable = true;
    }
    desc1 = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator ? decorator(target, property, desc) || desc : desc;
    }, desc1);
    var hasAccessor = Object.prototype.hasOwnProperty.call(desc1, "get") || Object.prototype.hasOwnProperty.call(desc1, "set");
    if (context && desc1.initializer !== void 0 && !hasAccessor) {
        desc1.value = desc1.initializer ? desc1.initializer.call(context) : void 0;
        desc1.initializer = undefined;
    }
    if (hasAccessor) {
        delete desc1.writable;
        delete desc1.initializer;
        delete desc1.value;
    }
    if (desc1.initializer === void 0) {
        Object.defineProperty(target, property, desc1);
        desc1 = null;
    }
    return desc1;
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    query getDataForBasicInfo($websiteId: ID) {\n      stores(websiteId: $websiteId) {\n        items {\n          label: name\n          value: _id\n          acceptServe\n          acceptGo\n          schedulingOrdersDays\n          address {\n            placeId\n          }\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  mutation setPreferencesBasicOptions(\n    $websiteId: ID\n    $storeId: ID\n    $placeId: ID\n    $deliveryType: ID\n  ) {\n    setUserPreferences(\n      websiteId: $websiteId\n      storeId: $storeId\n      placeId: $placeId\n      deliveryType: $deliveryType\n    ) {\n      _id\n      deliveryType\n      timeLabel\n      time\n      itsStoreOpenAtTime\n      placeId\n      menuId\n      tableName\n      directions {\n        duration\n      }\n      website {\n        _id\n        name\n      }\n      websiteId\n      storeId\n      deliverAt\n      time\n      channel\n      shouldHidePrice\n      store {\n        _id\n        name\n        schedule {\n          itsOpenNow: itsAvailableAt(\n            websiteId: $websiteId\n            storeId: $storeId\n            shouldAddMessage: true\n          )\n        }\n        schedulingOrdersDays\n        minimumAnticipationDays\n        currentPreparationDuration\n        currentDeliveryDuration\n        timeFormat\n        availableScheduleDaysOptions {\n          label\n          value\n        }\n        nextAvailableDate\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

/* eslint-disable @typescript-eslint/ban-types */ 






















var _class, _dec, _dec1;
var _dec2 = (0,withGraphQL["default"])((0,lib["default"])(_templateObject()), {
    loading: null
}), _dec3 = (0,withMutation["default"])((0,lib["default"])(_templateObject1()));
var UpdateBasicOptions = _class = _dec3(_class = (0,withWebsiteId/* default */.Z)(_class = _dec2(_class = (0,withMessage/* default */.Z)(((_class = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(UpdateBasicOptions, _Component);
    var _super = _createSuper(UpdateBasicOptions);
    function UpdateBasicOptions() {
        _classCallCheck(this, UpdateBasicOptions);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            loading: false
        };
        return _this;
    }
    var _proto = UpdateBasicOptions.prototype;
    _proto.onChange = function onChange(params) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            var fields, final;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (_this.props.preferences.websiteId) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        fields = [
                            "websiteId",
                            "storeId",
                            "placeId",
                            "deliveryType"
                        ];
                        final = pick_default().apply(void 0, [
                            _objectSpread({}, _this.props.preferences, params)
                        ].concat(_toConsumableArray(fields)));
                        if (!isEqual_default()(pick_default().apply(void 0, [
                            _this.props.preferences
                        ].concat(_toConsumableArray(fields))), final)) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 7:
                        _this.setState({
                            loading: true
                        });
                        _ctx.next = 10;
                        return _this.props.setPreferencesBasicOptions(final, {
                        });
                    case 10:
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        _this.props.showMessage(_ctx.t0);
                    case 15:
                        _this.setState({
                            loading: false
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }))();
    };
    _proto.renderStore = function renderStore() {
        var _props = this.props, _stores = _props.stores, stores = _stores === void 0 ? {
            items: []
        } : _stores, _preferences = _props.preferences, preferences = _preferences === void 0 ? {} : _preferences;
        var deliveryType = preferences.deliveryType;
        if (!deliveryType) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreMessage/* default */.Z, {
                preferences: preferences
            });
        }
        var filteredStores = stores.items.filter(function(store) {
            if (!store.address || !store.address.placeId) {
                return false;
            }
            if (deliveryType === "go" && store.acceptGo) {
                return true;
            }
            if (deliveryType === "serve" && store.acceptServe) {
                return true;
            }
            return false;
        });
        if (filteredStores.length === 1) {
            if (!this.props.preferences) return;
            if (this.state.loading) return;
            if (this.props.preferences.storeId !== filteredStores[0].value) {
                var _this = this;
                setTimeout(function() {
                    return _this.onChange({
                        storeId: filteredStores[0].value
                    });
                }, 0);
            }
            return;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
            fieldName: "storeId",
            label: this.props.t("order.options.updateBasicOptions.labelChooseStore"),
            placeholder: this.props.t("order.options.updateBasicOptions.labelSelectStore"),
            type: Select/* default */.Z,
            className: (UpdateBasicOptions_styles_module_default()).addressSelector,
            options: filteredStores
        });
    };
    _proto.renderTime = function renderTime() {
        var _preferences = this.props.preferences, placeId = _preferences.placeId, deliveryType = _preferences.deliveryType, store = _preferences.store, time = _preferences.time;
        if (!store) return;
        if (deliveryType === "serve" && !store.acceptServeSchedulingOrders) return;
        if (deliveryType === "serve" && time === "now") return;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Time/* default */.Z, {
            preferences: this.props.preferences,
            // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
            showDirections: !!placeId && placeId !== "no-deliver"
        });
    };
    _proto.renderTableName = function renderTableName() {
        var _preferences = this.props.preferences, deliveryType = _preferences.deliveryType, store = _preferences.store, time = _preferences.time;
        if (!store) return;
        if (deliveryType !== "serve") return;
        if (time !== "now") return;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableName/* default */.Z, {
            preferences: this.props.preferences
        });
    };
    _proto.renderDeliveryOptions = function renderDeliveryOptions() {
        var loading = this.state.loading;
        if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingText/* default */.Z, {
            lines: 2
        });
        var deliveryType = this.props.preferences.deliveryType;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                deliveryType === "delivery" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryOptions, {
                    preferences: this.props.preferences,
                    isFromHeader: this.props.isFromHeader,
                    layout: this.props.layout
                }),
                deliveryType !== "delivery" && this.renderStore(),
                deliveryType !== "delivery" && this.renderTime(),
                deliveryType !== "delivery" && this.renderTableName()
            ]
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading/* default */.Z, {}),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (UpdateBasicOptions_styles_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(simple_react_form_lib.Form, {
                    state: this.props.preferences,
                    onChange: this.onChange,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
                            fieldName: "deliveryType",
                            type: DeliveryType/* default */.Z,
                            disabled: this.state.loading
                        }),
                        this.renderDeliveryOptions(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreName/* default */.Z, {
                            preferences: this.props.preferences,
                            website: {
                                showStoreName: this.props.showStoreName
                            },
                            isOnMenu: true
                        })
                    ]
                })
            })
        });
    };
    return UpdateBasicOptions;
}(react.Component)) || _class, _dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    void 0
]), _applyDecoratedDescriptor(_class.prototype, "onChange", [
    esm["default"],
    _dec,
    _dec1
], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _class)) || _class) || _class) || _class) || _class;
/* harmony default export */ var Options_UpdateBasicOptions = ((0,dist_esm/* withTranslation */.Zh)()((0,router.withRouter)(UpdateBasicOptions)));


/***/ }),

/***/ 56498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ WrappedSelectProduct; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(54356);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-click-outside/build/index.js
var build = __webpack_require__(48683);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 3 modules
var Transition = __webpack_require__(23594);
// EXTERNAL MODULE: ./src/components/Loading/index.tsx
var Loading = __webpack_require__(69528);
// EXTERNAL MODULE: ./src/components/NoSSR/index.tsx
var NoSSR = __webpack_require__(4295);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/index.tsx
var SuspenseLoading = __webpack_require__(75288);
// EXTERNAL MODULE: ./src/hooks/useDisableScroll.ts
var useDisableScroll = __webpack_require__(1287);
// EXTERNAL MODULE: ./src/hooks/useKeyboardEvent.ts
var useKeyboardEvent = __webpack_require__(1626);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/styles.module.css
var styles_module = __webpack_require__(62953);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/components/MultilineText/index.tsx
var MultilineText = __webpack_require__(52544);
// EXTERNAL MODULE: ./src/helpers/track/useTrackEcommerceEvent.ts + 6 modules
var useTrackEcommerceEvent = __webpack_require__(55870);
// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 37 modules
var esm = __webpack_require__(12284);
// EXTERNAL MODULE: ./src/components/InformativeStamps/index.tsx + 1 modules
var InformativeStamps = __webpack_require__(79989);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/styles.module.css
var Modifiers_styles_module = __webpack_require__(45546);
var Modifiers_styles_module_default = /*#__PURE__*/__webpack_require__.n(Modifiers_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Comments/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var translatePrefix = "order.products.productsContent.selectProduct.inner.details.modifiers.comments";
var Text = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Text, _Component);
    var _super = _createSuper(Text);
    function Text() {
        _classCallCheck(this, Text);
        return _super.apply(this, arguments);
    }
    var _proto = Text.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Modifiers_styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Modifiers_styles_module_default()).labelContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Modifiers_styles_module_default()).label,
                        children: this.props.t("".concat(translatePrefix, ".labelSpecialInstructions"))
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                    value: this.props.value || "",
                    onChange: function(event) {
                        return _this.props.onChange(event.target.value);
                    },
                    className: (Modifiers_styles_module_default()).textarea,
                    placeholder: this.props.t("".concat(translatePrefix, ".labelIncludeNote"))
                })
            ]
        });
    };
    return Text;
}(react.Component);
/* harmony default export */ var Comments = ((0,esm/* withTranslation */.Zh)()(Text));

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/styles.module.css
var Modifier_styles_module = __webpack_require__(51693);
var Modifier_styles_module_default = /*#__PURE__*/__webpack_require__.n(Modifier_styles_module);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/styles.module.css
var Option_styles_module = __webpack_require__(84715);
var Option_styles_module_default = /*#__PURE__*/__webpack_require__.n(Option_styles_module);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/Radio/styles.module.css
var Radio_styles_module = __webpack_require__(12563);
var Radio_styles_module_default = /*#__PURE__*/__webpack_require__.n(Radio_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/Radio/index.tsx




function Radio(props) {
    var Icon = props.count ? index_esm/* MdRadioButtonChecked */.br6 : index_esm/* MdRadioButtonUnchecked */.bSN;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Radio_styles_module_default()).container,
        onClick: props.select,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
            size: 24
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/Checkbox/styles.module.css
var Checkbox_styles_module = __webpack_require__(85792);
var Checkbox_styles_module_default = /*#__PURE__*/__webpack_require__.n(Checkbox_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/Checkbox/index.tsx




function Checkbox(props) {
    var Icon = props.count ? index_esm/* MdCheckBox */.y5A : index_esm/* MdCheckBoxOutlineBlank */.hrt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: props.count || props.canAdd ? (Checkbox_styles_module_default()).container : (Checkbox_styles_module_default()).containerDisabled,
        onClick: props.toggle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
            size: 24
        })
    });
};

// EXTERNAL MODULE: ./src/i18n/formatNumber/index.ts + 3 modules
var formatNumber = __webpack_require__(38698);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/Count/styles.module.css
var Count_styles_module = __webpack_require__(9899);
var Count_styles_module_default = /*#__PURE__*/__webpack_require__.n(Count_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/Count/index.tsx





function Count(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Count_styles_module_default()).activeContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: props.count > 0 ? (Count_styles_module_default()).icon : (Count_styles_module_default()).iconDisabled,
                onClick: props.subtract,
                role: "button",
                "aria-label": "remove_button",
                "aria-disabled": props.count === 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdRemoveCircleOutline */.X6R, {
                    size: 24,
                    "aria-label": "remove_icon"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Count_styles_module_default()).count,
                "aria-label": "option_count",
                children: (0,formatNumber/* default */.Z)(props.count, "0,0")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: props.canAdd ? (Count_styles_module_default()).icon : (Count_styles_module_default()).iconDisabled,
                onClick: props.add,
                role: "button",
                "aria-label": "add_button",
                "aria-disabled": !props.canAdd,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdAddCircleOutline */.OrI, {
                    size: 24,
                    "aria-label": "add_icon"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Input/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function Input(props) {
    var option = props.option, modifier = props.modifier;
    if (modifier.max === 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, _objectSpread({}, props));
    }
    if (option.max === 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, _objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Count, _objectSpread({}, props));
};

// EXTERNAL MODULE: ./src/i18n/formatNumber/Component.tsx
var Component = __webpack_require__(18085);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Price/styles.module.css
var Price_styles_module = __webpack_require__(94622);
var Price_styles_module_default = /*#__PURE__*/__webpack_require__.n(Price_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/Price/index.tsx





function Price(props) {
    var option = props.option;
    var t = (0,esm/* useTranslation */.$G)("generic", {
        keyPrefix: "fields"
    }).t;
    var availability = option.availabilityAt;
    if (option.isOutOfStock) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Price_styles_module_default()).outOfStock,
        children: t("outOfStock")
    });
    if (!availability.price) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Price_styles_module_default()).price,
        children: [
            availability.price >= 0 ? "+" : "-",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                value: Math.abs(availability.price)
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/clone.js
var clone = __webpack_require__(66678);
var clone_default = /*#__PURE__*/__webpack_require__.n(clone);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/Option/index.tsx
function Option_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Option_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Option_defineProperty(target, key, source[key]);
        });
    }
    return target;
}






function Option(props) {
    var modifier = props.modifier, option = props.option, optionsIds = props.optionsIds, onChange = props.onChange, image = props.image;
    var count = optionsIds.filter(function(optionId) {
        return optionId === option._id;
    }).length;
    var canAdd = true;
    if (option.max && count >= option.max) {
        canAdd = false;
    }
    if (modifier.max && optionsIds.length >= modifier.max) {
        canAdd = false;
    }
    if (option.isOutOfStock) {
        canAdd = false;
    }
    var add = function() {
        if (!canAdd) return;
        var value = clone_default()(optionsIds);
        value.push(option._id);
        onChange(value);
    };
    var subtract = function() {
        if (option.isOutOfStock) return;
        var value = clone_default()(optionsIds);
        var index = value.indexOf(option._id);
        if (index > -1) {
            value.splice(index, 1);
        }
        onChange(value);
    };
    var toggle = function() {
        if (optionsIds.includes(option._id)) {
            subtract();
        } else {
            add();
        }
    };
    var select = function() {
        if (optionsIds.includes(option._id)) {
            subtract();
        } else {
            onChange([
                option._id
            ]);
        }
    };
    var defaultAction = modifier.max === 1 ? select : option.max === 1 ? toggle : add;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(option.isOutOfStock ? (Option_styles_module_default()).optionOutOfStock : (Option_styles_module_default()).optionContainer, " ").concat(image ? (Option_styles_module_default()).optionContainerImage : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(image ? (Option_styles_module_default()).hideInput : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, Option_objectSpread({}, props, {
                    count: count,
                    add: add,
                    subtract: subtract,
                    toggle: toggle,
                    select: select,
                    canAdd: canAdd
                }))
            }),
            image ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((Option_styles_module_default()).imageContainer, " ").concat(count ? (Option_styles_module_default()).imageContainerSelected : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: option.image && option.image[0] ? option.image[0].imageLarge : null,
                        onClick: defaultAction,
                        alt: option.name,
                        className: "".concat((Option_styles_module_default()).optionImage, " ").concat(select ? (Option_styles_module_default()).optionImageSelected : "")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: option.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, Option_objectSpread({}, props))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Option_styles_module_default()).numberContainer,
                        children: [
                            count > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Option_styles_module_default()).numberMinus,
                                onClick: subtract,
                                children: "-"
                            }) : null,
                            count ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Option_styles_module_default()).numberItems,
                                children: count
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((Option_styles_module_default()).numberPlus, " ").concat(canAdd ? "" : (Option_styles_module_default()).hideInput),
                                onClick: add,
                                children: "+"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Option_styles_module_default()).optionLabel,
                        onClick: defaultAction,
                        "aria-label": option.name,
                        children: option.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Price, Option_objectSpread({}, props))
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/SelectionInfo/styles.module.css
var SelectionInfo_styles_module = __webpack_require__(61443);
var SelectionInfo_styles_module_default = /*#__PURE__*/__webpack_require__.n(SelectionInfo_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/SelectionInfo/index.tsx




function SelectionInfo(props) {
    var min = props.min, max = props.max, selected = props.selected;
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.products.productsContent.selectProduct.inner.details.modifiers.modifier.selectionInfo"
    }).t;
    // only display information for multiple selection Modifiers.
    if (max === 1) return null;
    var infiniteMax = max === 0 || max == null;
    var rangeInfo = function() {
        // return if display range is not feasible.
        if (!infiniteMax && min > max) return null;
        // user understands that the min is 1.
        if (min <= 1) return null;
        if (min === max) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: t("labelSelectMin", {
                    min: min
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: t("labelSelectAtLeast", {
                min: min
            })
        });
    };
    var selectedInfo = function() {
        if (selected === 0) return null;
        if (selected === 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (SelectionInfo_styles_module_default()).selected,
                children: t("labelSelectedProduct", {
                    selected: selected
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (SelectionInfo_styles_module_default()).selected,
            children: t("labelSelectedProducts", {
                selected: selected
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            rangeInfo(),
            selectedInfo()
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/Modifier/index.tsx






function Modifier(props) {
    var product = props.product, modifier = props.modifier, optionsIds = props.value, onChange = props.onChange;
    var options = modifier.options.filter(function(option) {
        return option.availabilityAt && option.availabilityAt.available;
    });
    var t = (0,esm/* useTranslation */.$G)("generic", {
        keyPrefix: "fields"
    }).t;
    var minSelection = modifier.min, maxSelection = modifier.max;
    var tagLabel = modifier.optional ? "optional" : "required";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Modifier_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Modifier_styles_module_default()).labelContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((Modifier_styles_module_default()).tag, " ").concat(modifier.optional ? "" : (Modifier_styles_module_default()).notOptional),
                        children: t(tagLabel)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Modifier_styles_module_default()).label,
                        children: modifier.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Modifier_styles_module_default()).description,
                        children: modifier.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Modifier_styles_module_default()).selectionInfo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectionInfo, {
                            min: minSelection,
                            max: maxSelection,
                            selected: optionsIds.length
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((Modifier_styles_module_default()).options, " ").concat(modifier.isImageModifier ? (Modifier_styles_module_default()).imageOptions : ""),
                children: options.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                        optionsIds: optionsIds,
                        onChange: onChange,
                        option: option,
                        product: product,
                        modifier: modifier,
                        image: modifier.isImageModifier
                    }, option._id);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/simple-react-form/lib/index.js
var lib = __webpack_require__(40191);
// EXTERNAL MODULE: ./src/components/fields/ObjectField/index.tsx
var ObjectField = __webpack_require__(47758);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getFilteredModifiers.ts
var getFilteredModifiers = __webpack_require__(58861);
// EXTERNAL MODULE: ./node_modules/@packages/apollo-hooks/lib/index.js
var apollo_hooks_lib = __webpack_require__(25074);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var graphql_tag_lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/useMenuConfiguration.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        '\n      query getBlockMenuCommentsConfiguration_cached($websiteId: ID) {\n        sectionConfiguration(section: "menu", websiteId: $websiteId) {\n          _id\n          menu {\n            blockCommentsOnProducts\n          }\n        }\n      }\n    '
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useMenuConfiguration() {
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var sectionConfiguration = (0,apollo_hooks_lib.useApolloQuery)({
        query: (0,graphql_tag_lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first"
    }).sectionConfiguration;
    if (!sectionConfiguration) return {};
    if (!sectionConfiguration.menu) return {};
    return sectionConfiguration.menu;
};

// EXTERNAL MODULE: ./node_modules/react-app-events/lib/useOnEvent.js
var useOnEvent = __webpack_require__(80967);
// EXTERNAL MODULE: ./src/hooks/useRef.ts
var useRef = __webpack_require__(53630);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./src/helpers/misc/sleep.ts
var sleep = __webpack_require__(77712);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Modifiers/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}













function Modifiers(props) {
    var product = props.product, state = props.state, onChange = props.onChange;
    var menuConfiguration = useMenuConfiguration();
    var refs = (0,useRef/* default */.Z)({}).current;
    var ref1 = _slicedToArray((0,useState/* default */.Z)(), 2), shakingId = ref1[0], setShakingId = ref1[1];
    (0,useOnEvent["default"])("scrollToRequiredModifier", function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(modifier) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = refs[modifier._id];
                        if (ref) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        ref.scrollIntoView({
                            behavior: "smooth"
                        });
                        setShakingId(modifier._id);
                        _ctx.next = 7;
                        return (0,sleep/* default */.Z)(1500);
                    case 7:
                        setShakingId(null);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(modifier) {
            return _ref.apply(this, arguments);
        };
    }());
    if (!product.availabilityAt) return null;
    var modifiers = (0,getFilteredModifiers/* default */.Z)(product.modifiers);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib.Form, {
                state: state,
                onChange: onChange,
                children: [
                    modifiers.map(function(modifier) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "animated ".concat(shakingId === modifier._id ? "shake" : ""),
                            ref: function(ref) {
                                return refs[modifier._id] = ref;
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                fieldName: "modifiers.".concat(modifier.index),
                                type: ObjectField/* default */.Z,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                                    fieldName: "optionsIds",
                                    type: Modifier,
                                    modifier: modifier,
                                    product: product
                                })
                            })
                        }, modifier._id);
                    }),
                    "blockCommentsOnProducts" in menuConfiguration && menuConfiguration.blockCommentsOnProducts ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Field, {
                        fieldName: "comment",
                        type: Comments
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: 40
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useTrack.ts
var useTrack = __webpack_require__(25932);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/Track.tsx


function Track(props) {
    var track = (0,useTrack/* default */.Z)();
    (0,useEffect/* default */.Z)(function() {
        track("viewProduct", {
            productId: props.productId
        });
    }, []);
    return null;
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/styles.module.css
var Details_styles_module = __webpack_require__(97513);
var Details_styles_module_default = /*#__PURE__*/__webpack_require__.n(Details_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Details/index.tsx










var Details_translatePrefix = "order.products.productsContent.selectProduct.inner.details";
function Details(props) {
    var product = props.product;
    var t = (0,esm/* useTranslation */.$G)("website").t;
    var trackEcommerceEvent = (0,useTrackEcommerceEvent/* default */.Z)();
    var informativeStampsList = product === null || product === void 0 ? void 0 : product.informativeStamps;
    (0,useEffect/* default */.Z)(function() {
        trackEcommerceEvent(useTrackEcommerceEvent/* ECOMMERCE_EVENTS.VIEWCONTENT */.X.VIEWCONTENT, {
            product: product
        });
    }, [
        product._id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Details_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Details_styles_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (Details_styles_module_default()).name,
                        children: product.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Details_styles_module_default()).informativeStampsContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InformativeStamps/* default */.Z, {
                            stamps: informativeStampsList,
                            iconOnly: false
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (Details_styles_module_default()).description,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MultilineText/* default */.Z, {
                                children: product.description
                            }),
                            product.maxPurchaseQuantity ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "* ".concat(t("".concat(Details_translatePrefix, ".maxPurchaseQuantity"), {
                                    max: product.maxPurchaseQuantity
                                }))
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modifiers, {
                        product: product,
                        state: props.state,
                        onChange: props.onChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Track, {
                productId: product._id
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(40076);
// EXTERNAL MODULE: ./src/helpers/posthog/index.ts
var posthog = __webpack_require__(53023);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Tooltip/index.js
var Tooltip = __webpack_require__(34053);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/index.tsx + 1 modules
var UpdateBasicOptions = __webpack_require__(82096);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/Delete/styles.module.css
var Delete_styles_module = __webpack_require__(1795);
var Delete_styles_module_default = /*#__PURE__*/__webpack_require__.n(Delete_styles_module);
// EXTERNAL MODULE: ./src/hooks/useMessage.ts
var useMessage = __webpack_require__(5528);
// EXTERNAL MODULE: ./src/data/mutations/cart/deleteCartItem.ts
var deleteCartItem = __webpack_require__(93865);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/Delete/useDelete.ts
function useDelete_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function useDelete_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                useDelete_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                useDelete_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




function useDelete() {
    var mutate = (0,apollo_hooks_lib.useMutate)();
    var showMessage = (0,useMessage/* default */.Z)();
    return function() {
        var _ref = useDelete_asyncToGenerator(runtime_default().mark(function _callee(cartItemId) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return mutate({
                            mutation: deleteCartItem/* deleteCartItemMutation */.r,
                            variables: {
                                cartItemId: cartItemId
                            },
                            refetchQueries: [
                                "getMyCart",
                                "getMyOrderPreferences",
                                "getCheckout"
                            ]
                        });
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        showMessage(_ctx.t0);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function(cartItemId) {
            return _ref.apply(this, arguments);
        };
    }();
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/Delete/index.tsx
function Delete_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Delete_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Delete_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Delete_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}







function Delete(props) {
    var close = props.close, cartItem = props.cartItem;
    var deleteItem = useDelete();
    var remove = function() {
        var _ref = Delete_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        (0,posthog.sendPosthogData)(posthog.EVENTS.clicked.cartRemoveProduct);
                        close();
                        _ctx.next = 5;
                        return (0,sleep/* default */.Z)(200);
                    case 5:
                        _ctx.next = 7;
                        return deleteItem(cartItem._id);
                    case 7:
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        console.log(_ctx.t0);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function remove() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Delete_styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: (Delete_styles_module_default()).button,
            onClick: remove,
            children: "Eliminar"
        })
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/styles.module.css
var Actions_styles_module = __webpack_require__(58471);
var Actions_styles_module_default = /*#__PURE__*/__webpack_require__.n(Actions_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Actions/index.tsx
function Actions_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function Actions_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function Actions_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Actions_getPrototypeOf(o1) {
    Actions_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return Actions_getPrototypeOf(o1);
}
function Actions_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Actions_setPrototypeOf(subClass, superClass);
}
function Actions_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Actions_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Actions_possibleConstructorReturn(self, call) {
    if (call && (Actions_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return Actions_assertThisInitialized(self);
}
function Actions_setPrototypeOf(o2, p1) {
    Actions_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return Actions_setPrototypeOf(o2, p1);
}
var Actions_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function Actions_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function Actions_createSuper(Derived) {
    var hasNativeReflectConstruct = Actions_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = Actions_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = Actions_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return Actions_possibleConstructorReturn(this, result);
    };
}












var Actions_translatePrefix = "order.products.productsContent.selectProduct.inner.actions";
var Actions = /*#__PURE__*/ function(_Component) {
    "use strict";
    Actions_inherits(Actions, _Component);
    var _super = Actions_createSuper(Actions);
    function Actions() {
        Actions_classCallCheck(this, Actions);
        return _super.apply(this, arguments);
    }
    var _proto = Actions.prototype;
    _proto.renderButton = function renderButton(adds, param) {
        var maxPurchaseQuantity = param.maxPurchaseQuantity, cartItem = param.cartItem;
        var _this = this;
        var Icon = adds ? index_esm/* MdAdd */.x06 : index_esm/* MdRemove */.eqC;
        var diff = adds ? 1 : -1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Actions_styles_module_default()).amountButton,
            onClick: function() {
                var amount = _this.props.state.amount + diff;
                (0,posthog.sendPosthogData)(posthog.EVENTS.clicked.productChangeAmount, Actions_objectSpread({
                    adds: adds,
                    amount: amount
                }, _this.props.product));
                if (amount === 0) return;
                if (maxPurchaseQuantity && amount > maxPurchaseQuantity) return;
                if (cartItem && cartItem.amount + amount > maxPurchaseQuantity) return;
                _this.props.onChange({
                    amount: amount
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                size: 20
            })
        });
    };
    _proto.renderPrice = function renderPrice() {
        var price = this.props.resume.price;
        if (!price) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
            value: Math.max(price, 0)
        });
    };
    _proto.renderNoStore = function renderNoStore() {
        var preferences = this.props.preferences;
        if (!preferences) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Actions_styles_module_default()).options,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: this.props.t("".concat(Actions_translatePrefix, ".labelAddAddressOrSelectStore"))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateBasicOptions/* default */.Z, {
                        preferences: preferences
                    })
                })
            ]
        });
    };
    _proto.renderNotAvailable = function renderNotAvailable() {
        var product = this.props.product;
        var message = product.availabilityAt.notAvailableMessage || this.props.t("".concat(Actions_translatePrefix, ".labelProductNotAvailable"));
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Actions_styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Actions_styles_module_default()).outOfStockMessage,
                    children: message
                }),
                this.renderDelete()
            ]
        });
    };
    _proto.renderAddButton = function renderAddButton() {
        var _this = this;
        var tooltipText = this.props.cartItem ? "edit" : "add";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            loading: this.props.isAddingToCart,
            className: (Actions_styles_module_default()).button,
            primary: true,
            onClick: function() {
                _this.props.add();
                if (_this.props.cartItem) {
                    (0,posthog.sendPosthogData)(posthog.EVENTS.clicked.saveEditProduct);
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
                content: !this.props.resume.ready ? this.props.t("".concat(Actions_translatePrefix, ".labelCompleteAll")) : null,
                children: this.props.t("fields.".concat(tooltipText), {
                    ns: "generic"
                })
            })
        });
    };
    _proto.renderOutOfStock = function renderOutOfStock() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Actions_styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Actions_styles_module_default()).outOfStockMessage,
                    children: this.props.t("".concat(Actions_translatePrefix, ".labelProductOutOfStock"))
                }),
                this.renderDelete()
            ]
        });
    };
    _proto.renderMaxPurchaseQuantity = function renderMaxPurchaseQuantity(maxPurchaseQuantity) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Actions_styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Actions_styles_module_default()).outOfStockMessage,
                    children: this.props.t("".concat(Actions_translatePrefix, ".labelMaxPurchaseQuantity"), {
                        max: maxPurchaseQuantity
                    })
                }),
                this.renderDelete()
            ]
        });
    };
    _proto.renderDelete = function renderDelete() {
        if (!this.props.cartItem) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete, {
            cartItem: this.props.cartItem,
            close: this.props.close
        });
    };
    _proto.render = function render() {
        var amount = this.props.state.amount;
        var _props = this.props, product = _props.product, isOutOfStock = _props.isOutOfStock, preferences = _props.preferences;
        var maxPurchaseQuantity = product.maxPurchaseQuantity;
        var cartItems = get_default()(preferences, "cart.items", []);
        var cartItem = cartItems.find(function(item) {
            return item.product._id === product._id;
        });
        if (isOutOfStock) return this.renderOutOfStock();
        if (!product.availabilityAt) return this.renderNoStore();
        if (!product.availabilityAt.available) return this.renderNotAvailable();
        if (cartItem && maxPurchaseQuantity && cartItem.amount >= maxPurchaseQuantity) return this.renderMaxPurchaseQuantity(maxPurchaseQuantity);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Actions_styles_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Actions_styles_module_default()).inner,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Actions_styles_module_default()).amount,
                            children: [
                                this.renderButton(false, {
                                    maxPurchaseQuantity: maxPurchaseQuantity,
                                    cartItem: cartItem
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Actions_styles_module_default()).amountValue,
                                    children: amount
                                }),
                                this.renderButton(true, {
                                    maxPurchaseQuantity: maxPurchaseQuantity,
                                    cartItem: cartItem
                                })
                            ]
                        }),
                        this.renderAddButton(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Actions_styles_module_default()).price,
                            children: this.renderPrice()
                        })
                    ]
                }),
                this.renderDelete()
            ]
        });
    };
    return Actions;
}(react.Component);
/* harmony default export */ var Inner_Actions = ((0,esm/* withTranslation */.Zh)()(Actions));

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/index.tsx + 4 modules
var useAdd = __webpack_require__(16337);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getResume.ts + 3 modules
var getResume = __webpack_require__(8184);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/getDefaultState.ts
function getDefaultState_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function getDefaultState_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            getDefaultState_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function getDefaultState(product, cartItem) {
    var productModifiers = (product === null || product === void 0 ? void 0 : product.modifiers) || [];
    if (cartItem) {
        return getDefaultState_objectSpread({}, cartItem, {
            modifiers: productModifiers.map(function(modifier) {
                var savedModifier1 = cartItem.modifiers.find(function(savedModifier) {
                    return savedModifier.modifierId === modifier._id;
                });
                return {
                    modifierId: modifier._id,
                    optionsIds: savedModifier1 ? savedModifier1.optionsIds || [] : []
                };
            })
        });
    }
    var modifiers = productModifiers.map(function(modifier) {
        return {
            modifierId: modifier._id,
            optionsIds: []
        };
    });
    return {
        modifiers: modifiers,
        comment: null,
        amount: 1
    };
};

// EXTERNAL MODULE: ./src/helpers/misc/hasWebpSupport.ts
var hasWebpSupport = __webpack_require__(6909);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(50361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useSetOutOfStock.ts
function useSetOutOfStock_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useSetOutOfStock_templateObject() {
    var data = useSetOutOfStock_taggedTemplateLiteral([
        "\n      query getProductDetailsOutOfStock(\n        $websiteId: ID\n        $productsIds: [ID]\n        $storeId: ID\n        $deliverAt: Date\n        $modifierOptionsIds: [ID]\n      ) {\n        outOfStockProducts: outOfStockProductsInList(\n          websiteId: $websiteId\n          productsIds: $productsIds\n          storeId: $storeId\n          deliverAt: $deliverAt\n        )\n        outOfStockModifierOptions: outOfStockModifierOptionsInList(\n          websiteId: $websiteId\n          modifierOptionsIds: $modifierOptionsIds\n          storeId: $storeId\n          deliverAt: $deliverAt\n        )\n      }\n    "
    ]);
    useSetOutOfStock_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function useSetOutOfStock(param) {
    var productParam = param.product, websiteId = param.websiteId, storeId = param.storeId, deliverAt = param.deliverAt;
    var ref;
    var product = (ref = cloneDeep_default()(productParam)) !== null && ref !== void 0 ? ref : {};
    var modifierOptionsIds = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (product.modifiers || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var modifiers = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = (modifiers.options || [])[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var option = _step1.value;
                    modifierOptionsIds.push(option._id);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var ref1 = (0,apollo_hooks_lib.useApolloQuery)({
        query: (0,graphql_tag_lib["default"])(useSetOutOfStock_templateObject()),
        variables: {
            productsIds: [
                product === null || product === void 0 ? void 0 : product._id
            ],
            modifierOptionsIds: modifierOptionsIds,
            websiteId: websiteId,
            storeId: storeId,
            deliverAt: deliverAt
        },
        partial: true,
        omit: !product || modifierOptionsIds.length === 0 || !storeId
    }), outOfStockProducts = ref1.outOfStockProducts, outOfStockModifierOptions = ref1.outOfStockModifierOptions;
    if (!outOfStockProducts || !outOfStockModifierOptions) return {
        outOfStockModifierOptions: [],
        isOutOfStock: null
    };
    return {
        outOfStockModifierOptions: outOfStockModifierOptions,
        isOutOfStock: !!outOfStockProducts.length
    };
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useProduct.ts
function useProduct_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useProduct_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useProduct_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function useProduct_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function useProduct_templateObject() {
    var data = useProduct_taggedTemplateLiteral([
        "\n      query getProductDetailsWeb_cached(\n        $productId: ID\n        $menuId: ID\n        $format: String\n        $websiteId: ID\n      ) {\n        product(productId: $productId, websiteId: $websiteId) {\n          _id\n          name\n          description\n          altImg\n          titleImg\n          urlVideo\n          informativeStamps\n          images {\n            _id\n            url\n            imageLarge: resizedURL(width: 1200, height: 1200, format: $format)\n          }\n          categories {\n            _id\n            name\n            internalName\n          }\n          isOutOfStock\n          maxPurchaseQuantity\n          modifiers {\n            _id\n            name\n            description\n            min\n            max\n            optional\n            isImageModifier\n            options {\n              _id\n              name\n              max\n              availabilityAt(menuId: $menuId) {\n                menuId\n                price\n                available\n              }\n              image {\n                _id\n                url\n                imageLarge: resizedURL(width: 300, height: 300, format: $format)\n              }\n            }\n          }\n          availabilityAt(menuId: $menuId) {\n            available\n            basePrice\n            finalPrice\n            notAvailableMessage\n          }\n        }\n      }\n    "
    ]);
    useProduct_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function useProduct(param) {
    var productId = param.productId, menuId = param.menuId, storeId = param.storeId, deliverAt = param.deliverAt, websiteId = param.websiteId;
    var product = (0,apollo_hooks_lib.useApolloQuery)({
        query: (0,graphql_tag_lib["default"])(useProduct_templateObject()),
        variables: {
            websiteId: websiteId,
            productId: productId,
            menuId: menuId,
            format: (0,hasWebpSupport/* default */.Z)() ? "webp" : "jpeg"
        }
    }).product;
    var ref = useSetOutOfStock({
        product: product,
        websiteId: websiteId,
        storeId: storeId,
        deliverAt: deliverAt
    }), outOfStockModifierOptions = ref.outOfStockModifierOptions, isOutOfStock = ref.isOutOfStock;
    var newModifier = product.modifiers.map(function(modifier) {
        return useProduct_objectSpread({}, modifier, {
            options: modifier.options.map(function(option) {
                return useProduct_objectSpread({}, option, {
                    isOutOfStock: outOfStockModifierOptions.includes(option._id)
                });
            })
        });
    });
    return useProduct_objectSpread({}, product, {
        isOutOfStock: isOutOfStock,
        modifiers: newModifier
    });
};

// EXTERNAL MODULE: ./src/hooks/useWidth.ts
var useWidth = __webpack_require__(9177);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Layout.tsx
function Layout_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Layout_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Layout_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Layout_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Layout_slicedToArray(arr, i) {
    return Layout_arrayWithHoles(arr) || Layout_iterableToArrayLimit(arr, i) || Layout_unsupportedIterableToArray(arr, i) || Layout_nonIterableRest();
}
function Layout_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Layout_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Layout_arrayLikeToArray(o, minLen);
}









function Layout(props) {
    var image = props.image, details = props.details, actions = props.actions;
    var width = (0,useWidth/* default */.ZP)();
    var scrollableContainer = (0,useRef/* default */.Z)(null);
    var ref = Layout_slicedToArray((0,useState/* default */.Z)(false), 2), showArrow = ref[0], setShowArrow = ref[1];
    (0,useEffect/* default */.Z)(function() {
        var element = scrollableContainer.current;
        if (!element) return;
        var hasVerticalScrollbar = element.scrollHeight > element.clientHeight;
        setShowArrow(hasVerticalScrollbar);
    }, []);
    var onScroll = function(event) {
        setShowArrow(false);
    };
    var arrow = /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* default */.ZP, {
        in: showArrow,
        timeout: 500,
        children: function(state) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default())["arrow_".concat(state)],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowDown */.Ix0, {
                    size: 50
                })
            });
        }
    });
    return width <= 768 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).containerMobile,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).scrollable,
                ref: scrollableContainer,
                onScroll: onScroll,
                children: [
                    arrow,
                    image,
                    details
                ]
            }),
            actions
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).containerDesktop,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).leftContent,
                children: image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).rightContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).detailsDesktop,
                        ref: scrollableContainer,
                        onScroll: onScroll,
                        children: [
                            arrow,
                            details
                        ]
                    }),
                    actions
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Images/styles.module.css
var Images_styles_module = __webpack_require__(658);
var Images_styles_module_default = /*#__PURE__*/__webpack_require__.n(Images_styles_module);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(10615);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/Images/index.tsx





var ReactPlayer = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2004).then(__webpack_require__.bind(__webpack_require__, 22004));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22004)
            ];
        }
    }
});
function Images(props) {
    var product = props.product;
    if ((!product.images || !product.images.length) && !product.urlVideo) return null;
    if (product.images.length === 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Images_styles_module_default()).imgContainer,
            children: product.urlVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactPlayer, {
                className: (Images_styles_module_default()).reactPlayer,
                url: product.urlVideo,
                width: "100%",
                height: "100%",
                muted: true,
                loop: true,
                config: {
                    vimeo: {
                        playerOptions: {
                            autoplay: true
                        }
                    },
                    youtube: {
                        playerVars: {
                            autoplay: 1
                        }
                    }
                },
                light: product.images[0].imageLarge
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: (Images_styles_module_default()).image,
                src: product.images[0].imageLarge,
                alt: product.altImg || product.name,
                title: product.titleImage || product.name
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Images_styles_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* Carousel */.lr, {
            showArrows: true,
            emulateTouch: true,
            showThumbs: false,
            showStatus: false,
            children: product.images.map(function(image, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Images_styles_module_default()).slide,
                    children: index === 0 && product.urlVideo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactPlayer, {
                        className: (Images_styles_module_default()).reactPlayer,
                        url: product.urlVideo,
                        width: "100%",
                        height: "100%",
                        muted: true,
                        loop: true,
                        config: {
                            vimeo: {
                                playerOptions: {
                                    autoplay: true
                                }
                            },
                            youtube: {
                                playerVars: {
                                    autoplay: 1
                                }
                            }
                        },
                        light: product.images[0].imageLarge
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: image.imageLarge,
                        alt: product.altImg || product.name,
                        title: product.titleImage || product.name
                    })
                }, index);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/index.tsx
function Inner_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Inner_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Inner_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Inner_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function Inner_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Inner_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Inner_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Inner_slicedToArray(arr, i) {
    return Inner_arrayWithHoles(arr) || Inner_iterableToArrayLimit(arr, i) || Inner_unsupportedIterableToArray(arr, i) || Inner_nonIterableRest();
}
function Inner_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Inner_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Inner_arrayLikeToArray(o, minLen);
}













function Inner(props) {
    var storeId = props.storeId, menuId = props.menuId, close = props.close, preferences = props.preferences, cartItem = props.cartItem;
    var deliverAt = (preferences ? preferences : {
        deliverAt: undefined
    }).deliverAt;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var isOutOfStock = props.product.isOutOfStock;
    var add = (0,useAdd/* default */.Z)();
    var product = useProduct({
        deliverAt: deliverAt,
        storeId: storeId,
        menuId: menuId,
        productId: props.product._id,
        websiteId: websiteId
    });
    var ref = Inner_slicedToArray((0,useState/* default */.Z)(getDefaultState(product, cartItem)), 2), state = ref[0], setState = ref[1];
    var ref1 = Inner_slicedToArray((0,useState/* default */.Z)(false), 2), loading = ref1[0], setLoading = ref1[1];
    var resume = (0,getResume/* default */.Z)(props, state, product);
    var image = /*#__PURE__*/ (0,jsx_runtime.jsx)(Images, {
        product: product
    });
    var details = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).content,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Details, {
            state: state,
            product: product,
            close: close,
            preferences: preferences,
            onChange: function(changes) {
                return setState(Inner_objectSpread({}, state, changes));
            }
        })
    });
    var actions = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (styles_module_default()).actions,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner_Actions, {
            preferences: preferences,
            product: product,
            isOutOfStock: isOutOfStock,
            state: state,
            resume: resume,
            isAddingToCart: loading,
            add: function() {
                return add(props, state, product, resume, {
                    setLoading: setLoading,
                    keepLoadingOnFinish: true
                });
            },
            cartItem: cartItem,
            close: close,
            onChange: function(changes) {
                return setState(Inner_objectSpread({}, state, changes));
            }
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        image: image,
        details: details,
        actions: actions
    });
};

// EXTERNAL MODULE: ./src/hooks/usePageMeta.ts
var usePageMeta = __webpack_require__(74322);
// EXTERNAL MODULE: ./src/i18n/getCurrencyCode.ts
var getCurrencyCode = __webpack_require__(2298);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/PageMeta.tsx



function PageMeta(props) {
    var product = props.product;
    var router = (0,next_router.useRouter)();
    var image = product.images && product.images[0];
    var offer = product.availabilityAt ? {
        "@type": "Offer",
        url: router.asPath,
        priceCurrency: (0,getCurrencyCode/* default */.Z)(),
        price: product.availabilityAt.finalPrice
    } : null;
    var schema = image ? {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: product.name,
        image: [
            image.imageLarge
        ],
        sku: product._id,
        description: product.description,
        offers: offer
    } : null;
    (0,usePageMeta/* default */.Z)(props.product.name, props.product.description, image, schema);
    return null;
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/styles.module.css
var SelectProduct_styles_module = __webpack_require__(58071);
var SelectProduct_styles_module_default = /*#__PURE__*/__webpack_require__.n(SelectProduct_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/index.tsx
function SelectProduct_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SelectProduct_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SelectProduct_defineProperty(target, key, source[key]);
        });
    }
    return target;
}















function SelectProduct(props) {
    var product = props.product, closeModal = props.close, open = props.open;
    var handleClose = function() {
        if (!open) return;
        closeModal();
    };
    (0,useKeyboardEvent/* default */.Z)("escape", function() {
        handleClose();
    });
    (0,useDisableScroll/* default */.Z)(open);
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            open ? (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "e89170ede354f9dc",
                children: "body{overflow:hidden}"
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* default */.ZP, {
                in: open,
                timeout: 350,
                /*#__PURE__*/ children: function(state) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SelectProduct_styles_module_default()).container + " " + (SelectProduct_styles_module_default())["container_" + state],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.Z, {
                            onClickOutside: handleClose,
                            className: (SelectProduct_styles_module_default()).dialog + " " + (SelectProduct_styles_module_default())["dialog_" + state],
                            children: state === "exited" ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (SelectProduct_styles_module_default()).close,
                                        onClick: handleClose,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdClose */.FU5, {
                                            size: 20
                                        })
                                    }),
                                    product ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading/* default */.Z, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner, SelectProduct_objectSpread({}, props))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta, {
                                                product: product
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (SelectProduct_styles_module_default()).center,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {})
                                    })
                                ]
                            })
                        })
                    });
                }
            })
        ]
    });
    return /*#__PURE__*/ react_dom.createPortal(content, document.querySelector("#modal-root"));
}
function WrappedSelectProduct(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoSSR/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectProduct, SelectProduct_objectSpread({}, props))
    });
};


/***/ }),

/***/ 1159:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selectTime":"_1DFpNFlSSkQcsaOUrf54qN"};

/***/ }),

/***/ 60170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"OWNo-JhqksOSn4oJWLbNb","label":"_1G7h8kGxYCt5SHAWliz3Kx","containerIcon":"_20m7mdxd-bsZiE04e409gL","addressSelector":"_1wCQDS2mswBxGlqQ8a8N0l"};

/***/ }),

/***/ 1795:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JoRnTgEaun7ZtSEiC9Sz1","button":"_2Gylcs6Gd7UanqPc-RfSRs"};

/***/ }),

/***/ 58471:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Ds2lk386UyIuMcV-nvmDH","inner":"SlT6i0zpq7ili5AVrEumo","options":"_2yS7O6Ld0Uiac1lHvdyiaF","button":"utsr2lmGxCnCqAjK8vs4p","amount":"_2ZMLX05i7jy0YC8GT8Vwwf","amountValue":"_26MYC0Sn55yJb88PvsahZ7","amountButton":"_2sNUjvormrWpWJWF7PN7f7 buttonShadow textColor","price":"_3kAJ7tjAKAJGta8ThwS8yn","selectStore":"_3uT5HRRM0qPJ1MeI5wXXda","outOfStockMessage":"_3R_2o2wTZ_6OoipvxttEvl"};

/***/ }),

/***/ 85792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"xerH9vwSvQ7VEdXkx8zAf","containerDisabled":"_2QTUUU1ewsuWVb84_fHbpm"};

/***/ }),

/***/ 9899:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"BuWWgPYDqG250C3qMov-H","containerDisabled":"_2K2mlwL6l06aYanhKdylpd","activeContainer":"_3_Qn-2M_TvQ5UkcfGvqzSW","icon":"_2lWxkLrkXPQZaASNV0manc","iconDisabled":"_1FAieCOwHu4Y-vtbmBSPmg","count":"_31f_67zycVqytnxGcQCsSh"};

/***/ }),

/***/ 12563:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3kV27tvAhzpj1LNK72PZue"};

/***/ }),

/***/ 94622:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"price":"_2hxnD5Lx2ip3InWc1Aertb","outOfStock":"QU8zNhr5kHvXmba3FYMML"};

/***/ }),

/***/ 84715:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"y4dYaokeIIGrzmqxg8Ayo","optionContainer":"_1W9OVcVbyb_pP9au5t9Peh","optionContainerImage":"_1O_d8Yg0vlaA61UG0E4vjd","optionOutOfStock":"_3u5xbaoTY5p0J7bZPatNqj _1W9OVcVbyb_pP9au5t9Peh","optionLabel":"XX5pjJEPk_efWwTQ_cxHX","optionImage":"_3oA9hhZ_JzmQWFwdHKWV-l","hideInput":"E5--VQrULLV7IoNNuQn3b","imageContainer":"_44HEuI20QKAc9phkZ4btU","imageContainerSelected":"_32GvzY3Js1R98oenHljKeD","numberContainer":"_1mk5Ig4v4yZIOnrFIl1kPj","numberItems":"_3gzF_F--GZM5tMIk5gszkt","numberMinus":"_1FiC_TIPGi5eXqiNLKwlEa","numberPlus":"doLORol8EHShgNhoju3IT"};

/***/ }),

/***/ 61443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"selected":"_2WEZ-nLsOkFOeisQ1AuMRb"};

/***/ }),

/***/ 51693:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"kLUSDCp4arP0T3QFI4BmX","labelContainer":"_1cugaZDZnAIYqz2RTnCMpk","label":"_77RG7gSF_oHyesFG79_Ts","description":"_2lGoFssr_gZRg8J1Klq_Cg","tag":"_29bt6nvWMHpvR_r57gf1zt","notOptional":"cnpdcjTUTd89ap-Lcz079","selectionInfo":"_1sozssAaggLkDFtqnMVAIu","options":"_3S3ZJYyrIVf0r62n_zei8b","imageOptions":"_28awjLkSowcaCQY-x97CDZ"};

/***/ }),

/***/ 45546:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2gtX98axT987NNuVNgqAnC","labelContainer":"_2hEyEszJqyXUDbcLOzWhwq secondaryBackgroundColor textColor","label":"_1GraXf-dADpgnQwE0t62Ms","description":"_2UyP4Q-ftkVbiLxZZVG4aV","notOptional":"FTbO4_uDt1CJfcOMzlxBG","textarea":"RCPEHPK-OcYLWNS_jnXqB secondaryBackgroundColor textColor","optionContainer":"_1ck6IsTsDqme2PH_IRyR0E","optionOutOfStock":"x7Hk9DReSXZWDFVNVpM26 _1ck6IsTsDqme2PH_IRyR0E","optionLabel":"_1ewo791xmwKLXPDtT1KqNy","input":"k7HJ9aK0F8srCkLcHBwPm","price":"u_WyTPujNnuuoSR01xqC6 descriptionTextColor","outOfStock":"_2NZH9iKtZ_i7jxk83Vi21a"};

/***/ }),

/***/ 97513:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1iadtdx2dCglITsAF7LVS6","content":"_2NGCbm7SldrDsMh4ZJTHU9","actions":"_3IRXxdt0lEbY1_3_o2vyej","name":"_3RsV8R40NNJ9jK-NrhRZx9 selectProductName","description":"FM-CatORsTn2R1JU7M6ji selectProductDescription descriptionTextColor","informativeStampsContainer":"_2fY0q2iES4bQLVVdFDQN7A"};

/***/ }),

/***/ 658:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3W6IztQUSTBfCNJFPl4ItX","imgContainer":"_3stT25Od4PxV9_wzgXO4Av","image":"gMI2mb51kuAVpRqCmS22","slide":"_2RAsqHbz1YcrVnpu14H57w","reactPlayer":"_3EAFqObRTLt_UAI9mxBOnT"};

/***/ }),

/***/ 62953:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"_3bdyN5X1w628ddqSFWNIbA","containerMobile":"_3y-fZjlt5EjfcpJv0j7Wn_","scrollable":"_2i_tz5gNfy2gn9ChXR9aNj","containerDesktop":"_1mJlXNibvXRVrfPi4Z6ebf","leftContent":"_1T6Zt2KD6v-ZwJrkBiapd9","rightContent":"_2wav8mmR1lM-kRtpqu2ckl","detailsDesktop":"_1jJDyvSFSK_hegHAbVxunE","arrow":"_2xbdpTyIC_XKAkhoagXd2Y animated pulse textColor","arrow_exited":"_1LQvFkXBefZkdCGlArkytV _2xbdpTyIC_XKAkhoagXd2Y animated pulse textColor","arrow_entering":"_26oQ_DpTL3GBEbIkk0hkKk _2xbdpTyIC_XKAkhoagXd2Y animated pulse textColor","arrow_entered":"_11qpLIaaLcpp1SvGjGqEw_ _2xbdpTyIC_XKAkhoagXd2Y animated pulse textColor","arrow_exiting":"Qp2EzSoxo0MvbXiBMtq8l _2xbdpTyIC_XKAkhoagXd2Y animated pulse textColor"};

/***/ }),

/***/ 58071:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3qm0leIlOCB8bqNfSIRtLd selectProductMenuContainer","container_exited":"_26VWVQY6qjzLakwkj4BiJ_","container_entering":"OcYH6syZV9fOm70yx6t0r","container_entered":"BGBfm51axrPbccRzOg_xr","container_exiting":"_2K2_Sot0cXgYRVXhS-O4hg","dialog":"_1_8EDJjeObbvBm2nhNqjc- backgroundColor textColor","dialog_exited":"_103h_O70FAfAWAJ5ejr4zt","dialog_entering":"_2_Gvk0Rhehaegv-XW362rj","dialog_entered":"_31d_xh7sVufzXKmyKgxajn","dialog_exiting":"jQjbDF1P2LgnZHEIyIA6_","close":"_1Ls29xfDQHSlASwBajrMGK","center":"_2loOKi2Csl68NtO2yZp6nb"};

/***/ })

}]);